import React, { useRef, useState } from "react";
import ReactPlayer from "react-player";
import { Rnd } from "react-rnd";
import "../styles/PopupVideo.css";

const PopupVideo = ({
  singlecam,
  cameraview,
  handleSixCamChange,
  handleFourCamChange,
  SixCamImg,
  FourCamImg,
  ballurls,
  activeCamTab,
  handleCamTab,
  toolData,
  shapeVisibility,
  activeTool,
  setActiveTool,
  setShapeVisibility,
  updateShape,
  shapes,
  onRectangleResize,
  hexToRGBA,
  fourcam,
  sixcam,
  handleVisibility,
}) => {
  const [zoom, setZoom] = useState(1); // 1 is 100%
  const playerRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const frameRate = 120; // Assuming 20 FPS

  const seekFrame = (forward = true) => {
    const currentTime = playerRef.current.getCurrentTime();
    const offset = 1 / frameRate;
    const newTime = forward
      ? currentTime + offset
      : Math.max(0, currentTime - offset);
    playerRef.current.seekTo(newTime, "seconds");
  };
  return (
    <div className="overlay">
      <div className="popup_scoretable">
        {singlecam && (
          <>
            {cameraview ? (
              <div style={{ display: "flex", height: "100vh" }}>
                {/* Left Toolbar */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginTop: 10,
                    maxHeight: "calc(100vh - 40px)", // adjust as needed
                    overflowY: "auto",
                    paddingRight: "5px",
                  }}
                  className="custom-scrollbar"
                >
                  <div>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <div>Cameras</div>
                      <div style={{ display: "flex", gap: "8px" }}>
                        <button
                          onClick={handleSixCamChange}
                          style={{
                            border: "2px solid #F5B623",
                            borderRadius: "6px",
                            backgroundColor:
                              cameraview === "6-cam" ? "#fdf7ec" : "#fff",
                            padding: "2px 2px",
                            cursor: "pointer",
                          }}
                        >
                          <img src={SixCamImg} alt="6 cam" width={28} />
                        </button>
                        <button
                          onClick={handleFourCamChange}
                          style={{
                            border: "2px solid #F5B623",
                            borderRadius: "6px",
                            backgroundColor:
                              cameraview === "4-cam" ? "#fdf7ec" : "#fff",
                            padding: "2px 2px",
                            cursor: "pointer",
                          }}
                        >
                          <img src={FourCamImg} alt="4 cam" width={28} />
                        </button>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      {Object.values(ballurls)
                        .filter(Boolean)
                        .map((url, index) => (
                          <div
                            key={index}
                            onClick={() => handleCamTab(`cam${index + 1}`, url)}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              backgroundColor:
                                activeCamTab === `cam${index + 1}`
                                  ? "#FFE197"
                                  : "#fff",
                              padding: "2px",
                              cursor: "pointer",
                            }}
                          >
                            <video
                              src={url}
                              width={80}
                              height={41}
                              style={{
                                objectFit: "cover",
                                borderRadius: "4px",
                                background: "#ddd",
                              }}
                              preload="metadata"
                              muted
                              playsInline
                              controls={false}
                            />
                            <div className="pe-2">Cam Angle {index + 1}</div>
                          </div>
                        ))}
                    </div>
                  </div>

                  <div>
                    <div className="my-3">Section title</div>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, 95px)",
                        gap: "10px",
                      }}
                    >
                      {toolData.map(({ id, label, icon }) => {
                        const isVisible =
                          shapeVisibility[activeCamTab]?.[id] || false;
                        return (
                          <div
                            key={id}
                            style={{
                              position: "relative",
                              cursor: "pointer",
                              borderRadius: "12px",
                              backgroundColor:
                                activeTool === id ? "#FFE197" : "#fff",
                              padding: "6px 3px",
                              textAlign: "center",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "5px",
                            }}
                            onClick={() => {
                              setActiveTool(id);
                              if (!isVisible) {
                                setShapeVisibility((prev) => ({
                                  ...prev,
                                  [activeCamTab]: {
                                    ...prev[activeCamTab],
                                    [id]: true,
                                  },
                                }));
                              }
                            }}
                          >
                            <label
                              style={{
                                position: "absolute",
                                left: "8px",
                                top: "8px",
                              }}
                              onClick={(e) => e.stopPropagation()} // prevent tool selection when toggling checkbox
                            >
                              <input
                                type="checkbox"
                                checked={isVisible}
                                onChange={() =>
                                  setShapeVisibility((prev) => ({
                                    ...prev,
                                    [activeCamTab]: {
                                      ...prev[activeCamTab],
                                      [id]: !prev[activeCamTab]?.[id],
                                    },
                                  }))
                                }
                              />
                            </label>
                            <img
                              src={icon}
                              alt={label}
                              style={{
                                width: 40,
                                height: 40,
                                border: "0.6px solid #F5B623",
                                borderRadius: 6,
                              }}
                            />
                            <span
                              style={{
                                fontSize: "10px",
                                color: activeTool === id ? "#4a4a4a" : "#666",
                                fontWeight:
                                  activeTool === id ? "bold" : "normal",
                              }}
                            >
                              {label}
                            </span>
                          </div>
                        );
                      })}

                      {activeTool && (
                        <div className="d-flex align-items-center justify-content-center flex-column">
                          <span
                            style={{
                              fontSize: "10px",
                              color: "#666",
                              fontWeight: "normal",
                            }}
                          >
                            Pick Color
                          </span>
                          <input
                            type="color"
                            value={shapes[activeTool]?.color}
                            onChange={(e) =>
                              updateShape(
                                activeTool,
                                activeCamTab,
                                { color: e.target.value },
                                true
                              )
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Main Video and Shapes */}
                <div style={{ position: "relative", flex: 1 }}>
                  <div className="">
                    <div
                      style={{
                        overflow: "hidden",
                        height: "90vh",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          transform: `scale(${zoom})`,
                          transformOrigin: "center center",
                          transition: "transform 0.2s ease",
                        }}
                      >
                        <ReactPlayer
                          ref={playerRef}
                          controls
                          playing={playing}
                          url={cameraview}
                          height="90vh"
                          width="100%"
                          config={{
                            file: {
                              attributes: { controlsList: "nodownload" },
                            },
                          }}
                          onContextMenu={(e) => e.preventDefault()}
                          onPlay={() => setPlaying(true)}
                          onPause={() => setPlaying(false)}
                        />
                      </div>
                    </div>

                    <div
                      style={{
                        marginTop: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0 20px",
                      }}
                    >
                      {/* Left: Frame Navigation */}
                      <div style={{ display: "flex", gap: "10px" }}>
                        <button
                          className="btn border-0 p-0"
                          onClick={() => seekFrame(false)}
                        >
                          <img
                            src={require("../assets/images/prev-frame.png")}
                            alt="Previous Frame"
                            height={43}
                            width={53}
                          />
                        </button>
                        <button
                          className="btn border-0 p-0 mb-3"
                          onClick={() => setPlaying(!playing)}
                        >
                          <img
                            src={
                              playing
                                ? require("../assets/images/play.png")
                                : require("../assets/images/pause.png")
                            }
                            alt={playing ? "Pause" : "Play"}
                            height={playing ? 27 : 20}
                            width={playing ? 15 : 14}
                          />
                        </button>
                        <button
                          className="btn border-0 p-0"
                          onClick={() => seekFrame(true)}
                        >
                          <img
                            src={require("../assets/images/next-frame.png")}
                            alt="Next Frame"
                            height={43}
                            width={53}
                          />
                        </button>
                      </div>

                      {/* Right: Zoom Controls */}
                      <div style={{ display: "flex", gap: "10px" }}>
                        <button
                          className="btn border-0 p-0"
                          onClick={() =>
                            setZoom((prev) => Math.min(prev + 0.1, 3))
                          }
                        >
                          <img
                            src={require("../assets/images/zoom-in.png")}
                            alt="Zoom In"
                            height={24}
                          />
                        </button>
                        <button
                          className="btn border-0 p-0"
                          onClick={() =>
                            setZoom((prev) => Math.max(prev - 0.1, 0.5))
                          }
                        >
                          <img
                            src={require("../assets/images/zoom-out.png")}
                            alt="Zoom Out"
                            height={24}
                          />
                        </button>
                      </div>
                    </div>
                  </div>

                  {Object.keys(shapes).map(
                    (key) =>
                      shapeVisibility[activeCamTab]?.[key] &&
                      shapes[key][activeCamTab] && (
                        <Rnd
                          key={key}
                          size={{
                            width:
                              key === "line1"
                                ? 2
                                : shapes[key][activeCamTab].width,
                            height:
                              key === "line2"
                                ? 2
                                : shapes[key][activeCamTab].height,
                          }}
                          position={{
                            x: shapes[key][activeCamTab].x,
                            y: shapes[key][activeCamTab].y,
                          }}
                          onDragStop={(e, d) =>
                            updateShape(key, activeCamTab, {
                              x: d.x,
                              y: d.y,
                            })
                          }
                          onResizeStop={(
                            e,
                            direction,
                            ref,
                            delta,
                            position
                          ) => {
                            if (key === "rectangle") {
                              onRectangleResize(
                                e,
                                direction,
                                ref,
                                delta,
                                position,
                                key,
                                activeCamTab
                              );
                            } else if (
                              key === "line1" &&
                              direction === "bottom"
                            ) {
                              updateShape(key, activeCamTab, {
                                height: parseInt(ref.style.height),
                                width: 2,
                              });
                            } else if (
                              key === "line2" &&
                              ["left", "right"].includes(direction)
                            ) {
                              updateShape(key, activeCamTab, {
                                width: parseInt(ref.style.width),
                                height: 2,
                                x: parseInt(ref.style.left),
                              });
                            } else if (
                              ["pitchingBall", "impactBall"].includes(key)
                            ) {
                              updateShape(key, activeCamTab, {
                                ...position,
                              });
                            }
                          }}
                          enableResizing={
                            activeTool === key && !key.includes("Ball")
                              ? key === "line1"
                                ? { bottom: true }
                                : key === "line2"
                                ? { left: true, right: true }
                                : {
                                    top: true,
                                    bottom: true,
                                    left: true,
                                    right: true,
                                  }
                              : false
                          }
                          disableDragging={activeTool !== key}
                          style={{
                            border:
                              key === "rectangle"
                                ? `2px solid ${shapes[key].color}`
                                : key.startsWith("line")
                                ? `1px solid ${shapes[key].color}`
                                : "none",
                            backgroundColor:
                              key === "rectangle"
                                ? hexToRGBA(shapes[key].color, 0.3)
                                : ["pitchingBall", "impactBall"].includes(key)
                                ? shapes[key].color
                                : "transparent",
                            borderRadius: key.includes("Ball") ? "50%" : "0",
                            cursor: activeTool === key ? "move" : "default",
                            zIndex: 1,
                          }}
                        />
                      )
                  )}
                </div>
              </div>
            ) : (
              <div className="d-flex align-items-center justify-content-center mt-4">
                This Video is not Available
              </div>
            )}
          </>
        )}

        {fourcam && (
          <>
            {ballurls ? (
              <div>
                <div
                  style={{ display: "flex", justifyContent: "space-around" }}
                >
                  <ReactPlayer
                    playing
                    controls
                    url={ballurls?.c1}
                    width="40%"
                    height="40%"
                  />
                  <ReactPlayer
                    playing
                    controls
                    url={ballurls?.c2}
                    width="40%"
                    height="40%"
                  />
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-around" }}
                >
                  <ReactPlayer
                    playing
                    controls
                    url={ballurls?.c3}
                    width="40%"
                    height="40%"
                  />
                  <ReactPlayer
                    playing
                    controls
                    url={ballurls?.c4}
                    width="40%"
                    height="40%"
                  />
                </div>
              </div>
            ) : (
              <div className="d-flex align-items-center justify-content-center mt-4">
                This Videos are not Available
              </div>
            )}
          </>
        )}

        {sixcam && (
          <div className="mt-4">
            <div
              className="mt-4"
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "10px",
                padding: "10px",
              }}
            >
              <ReactPlayer
                controls
                playing
                url={ballurls?.c1}
                width="100%"
                height="100%"
              />
              <ReactPlayer
                controls
                playing
                url={ballurls?.c2}
                width="100%"
                height="100%"
              />
              <ReactPlayer
                controls
                playing
                url={ballurls?.c3}
                width="100%"
                height="100%"
              />
              <ReactPlayer
                controls
                playing
                url={ballurls?.c4}
                width="100%"
                height="100%"
              />
              <ReactPlayer
                controls
                playing
                url={ballurls?.c5}
                width="100%"
                height="100%"
              />
              <ReactPlayer
                controls
                playing
                url={ballurls?.c6}
                width="100%"
                height="100%"
              />
            </div>
          </div>
        )}

        <button className="close-button" onClick={handleVisibility}>
          X
        </button>
        {(fourcam || sixcam) && (
          <button
            className="back-button-video"
            onClick={() => handleCamTab("cam1", ballurls?.c1)}
          >
            ←
          </button>
        )}
      </div>
    </div>
  );
};

export default PopupVideo;
